import { orgDashboardRouteGroup } from 'modules/orgDashboard/orgDashboard.routes';

export const orgDashboardCheckoutRouteGroup = orgDashboardRouteGroup.subgroup({
  path: 'single-checkout',
  params: ['orgId'],
});

export const orgDashboardCheckoutCartRoute =
  orgDashboardCheckoutRouteGroup.route({
    path: 'cart',
  });
